/**
 * Clinical paper-grid density. Low/medium/high must be obviously different:
 * low = majors only, medium = standard EEG paper, high = extra-fine minors.
 */

export type EegGridDensity = "low" | "medium" | "high";

export type EegGridDensityPlan = {
  showMinorTimeLines: boolean;
  showMinorAmplitudeLines: boolean;
  /** Multiplier on the medium time-minor step (0.2s at ≤20s/page). */
  timeMinorStepMultiplier: number;
  /** Minor amplitude spacing in millimetres of chart paper. */
  amplitudeMinorMm: number;
  minorTimeAlpha: number;
  minorAmplitudeAlpha: number;
};

export function resolveEegGridDensityPlan(
  density: EegGridDensity | undefined,
): EegGridDensityPlan {
  switch (density) {
    case "low":
      return {
        showMinorTimeLines: false,
        showMinorAmplitudeLines: false,
        timeMinorStepMultiplier: 1,
        amplitudeMinorMm: 1,
        minorTimeAlpha: 0,
        minorAmplitudeAlpha: 0,
      };
    case "high":
      return {
        showMinorTimeLines: true,
        showMinorAmplitudeLines: true,
        timeMinorStepMultiplier: 0.5,
        amplitudeMinorMm: 0.5,
        minorTimeAlpha: 0.55,
        minorAmplitudeAlpha: 0.28,
      };
    default:
      return {
        showMinorTimeLines: true,
        showMinorAmplitudeLines: true,
        timeMinorStepMultiplier: 1,
        amplitudeMinorMm: 1,
        minorTimeAlpha: 0.38,
        minorAmplitudeAlpha: 0.16,
      };
  }
}
